import ReportsDetailsDailyOptions from './ReportsDetailsDailyOptions';

export default ReportsDetailsDailyOptions;
